import { Box, CloseButton, Group, Text, ThemeIcon, useMantineTheme } from '@mantine/core';

const ChannelValue = ({ label, icon, color, onRemove, labelClass, ...others }) => {
    const theme = useMantineTheme();
    const isDark = theme.colorScheme === 'dark';

    return (
        <div {...others}>
            <Box
                sx={{
                    display: 'flex',
                    cursor: 'default',
                    alignItems: 'center',
                    backgroundColor: isDark ? theme.colors.dark[7] : theme.white,
                    border: `1px solid ${isDark ? theme.colors.dark[7] : theme.colors.gray[4]}`,
                    paddingLeft: theme.spacing.xs,
                    paddingRight: 2,
                    borderRadius: theme.radius.sm,
                }}>
                <Group spacing={4} noWrap sx={{ paddingRight: 4 }}>
                    <ThemeIcon size={18} variant='light' color={color} radius='sm'>
                        {icon}
                    </ThemeIcon>
                    <Text size='xs' sx={{ lineHeight: 1 }}>{label}</Text>
                </Group>
                <CloseButton onMouseDown={onRemove} variant='transparent' size={22} iconSize={14} tabIndex={-1} />
            </Box>
        </div>
    );
};

export default ChannelValue;
